<template>
  <div>
    <vx-card
      ><precificacaoComponent :subjectPermission="subjectPermission"
    /></vx-card>
  </div>
</template>
<script>
import precificacaoComponent from './list/PrecificacaoList.vue';
export default {
  name: 'precificacoes',
  components: { precificacaoComponent },
  data() {
    return {
      subjectPermission: 'Precificação Auto',
    };
  },
};
</script>
<style></style>
